import { mogamboRequestV3 } from '@src/api/utils';
import { TRACT_DASH, ECT_CREDENTIALS, METADATA } from '@src/const';

export const getAllECTsForClient = (clientId) => {
  const url = `${TRACT_DASH}${ECT_CREDENTIALS}${clientId}/${METADATA}`;
  return mogamboRequestV3(url, 'GET');
};

export const getECTForClient = (clientId, fqdn) => {
  const url = `${TRACT_DASH}${ECT_CREDENTIALS}${clientId}/`;
  return mogamboRequestV3(url, 'GET', { ect_fqdn: fqdn });
};

export const setupECTForClient = (
  clientId,
  businessId,
  fqdn,
  credentials,
  callbackURL
) => {
  const url = `${TRACT_DASH}${ECT_CREDENTIALS}${clientId}/`;
  return mogamboRequestV3(url, 'POST', {
    ect_fqdn: fqdn,
    business_id: businessId,
    credentials,
    callback_url: callbackURL,
  });
};

export const updateECTForClient = (clientId, businessId, fqdn, credentials) => {
  const url = `${TRACT_DASH}${ECT_CREDENTIALS}${clientId}/`;
  return mogamboRequestV3(url, 'PATCH', {
    business_id: businessId,
    ect_fqdn: fqdn,
    credentials,
  });
};

export const deleteEctForClient = (clientId, fqdn) => {
  const url = `${TRACT_DASH}${ECT_CREDENTIALS}${clientId}/delete/`;
  return mogamboRequestV3(url, 'POST', {
    ect_fqdn: fqdn,
  });
};
